const API_BASE_URL = process.env.REACT_APP_API_URL;

export const API_ENDPOINTS = {
  categories: {
    getAll: (includeInactive = false) => 
      `${API_BASE_URL}/categories${includeInactive ? '?includeInactive=true' : ''}`,
    getById: (id) => `${API_BASE_URL}/categories/${id}`,
    create: () => `${API_BASE_URL}/categories`,
    update: (id) => `${API_BASE_URL}/categories/${id}`,
    delete: (id) => `${API_BASE_URL}/categories/${id}`,
    toggleStatus: (id) => `${API_BASE_URL}/categories/${id}/toggle-status`,
    addSubcategory: (id) => `${API_BASE_URL}/categories/${id}/subcategories`,
  },
  
  products: {
    getAll: (params = {}) => {
      const queryParams = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          queryParams.append(key, value);
        }
      });
      return `${API_BASE_URL}/products?${queryParams.toString()}`;
    },
    getById: (id) => `${API_BASE_URL}/products/${id}`,
    create: () => `${API_BASE_URL}/products`,
    update: (id) => `${API_BASE_URL}/products/${id}`,
    delete: (id) => `${API_BASE_URL}/products/${id}`,
    bulkImport: () => `${API_BASE_URL}/products/bulk-import`,
    bulkDiscount: () => `${API_BASE_URL}/products/bulk-discount`,
    removeDiscount: () => `${API_BASE_URL}/products/remove-discount`,
    bulkDescription: () => `${API_BASE_URL}/products/bulk-description`,
    bulkPrice: () => `${API_BASE_URL}/products/bulk-price`,
    bulkTags: () => `${API_BASE_URL}/products/bulk-tags`,
    priceStats: () => `${API_BASE_URL}/products/price-stats`,
    cleanVariants: () => `${API_BASE_URL}/products/clean-variants`,
    sampleDescription: (categoryId) => `${API_BASE_URL}/products/sample-description/${categoryId}`,
  },

  productTags: {
    getAll: () => `${API_BASE_URL}/product-tags`,
    create: () => `${API_BASE_URL}/product-tags`,
    update: (id) => `${API_BASE_URL}/product-tags/${id}`,
    delete: (id) => `${API_BASE_URL}/product-tags/${id}`,
  },

  orders: {
    getAll: () => `${API_BASE_URL}/orders`,
    getById: (id) => `${API_BASE_URL}/orders/${id}`,
    create: () => `${API_BASE_URL}/orders`,
    update: (id) => `${API_BASE_URL}/orders/${id}`,
  },

  customOrders: {
    getAll: () => `${API_BASE_URL}/custom-orders`,
    getById: (id) => `${API_BASE_URL}/custom-orders/${id}`,
    create: () => `${API_BASE_URL}/custom-orders`,
    update: (id) => `${API_BASE_URL}/custom-orders/${id}`,
    updateStatus: (id) => `${API_BASE_URL}/custom-orders/${id}/status`,
  },

  media: {
    upload: () => `${API_BASE_URL}/media/upload`,
    getAll: () => `${API_BASE_URL}/media`,
    delete: (id) => `${API_BASE_URL}/media/${id}`,
    bulkDelete: () => `${API_BASE_URL}/media/bulk`,
  },

  chat: {
    sendMessage: () => `${API_BASE_URL}/chat`,
    getStats: () => `${API_BASE_URL}/chat/stats`,
  },

  customizableProducts: {
    getAll: (includeInactive = false) => 
      `${API_BASE_URL}/customizable-products${includeInactive ? '?includeInactive=true' : ''}`,
    getById: (id) => `${API_BASE_URL}/customizable-products/${id}`,
    create: () => `${API_BASE_URL}/customizable-products`,
    update: (id) => `${API_BASE_URL}/customizable-products/${id}`,
    delete: (id) => `${API_BASE_URL}/customizable-products/${id}`,
  },

  customizableOrders: {
    uploadImage: () => `${API_BASE_URL}/customizable-orders/upload-image`,
    create: () => `${API_BASE_URL}/customizable-orders`,
    getAll: () => `${API_BASE_URL}/customizable-orders/admin/all`,
    getById: (id) => `${API_BASE_URL}/customizable-orders/admin/${id}`,
    updateStatus: (id) => `${API_BASE_URL}/customizable-orders/admin/${id}/status`,
    stats: () => `${API_BASE_URL}/customizable-orders/admin/stats`,
  },

  merchandising: {
    requestQuote: () => `${API_BASE_URL}/merchandising/quote`,
  },

  priceConfig: {
    getAll: () => `${API_BASE_URL}/price-config`,
    getByCategory: (categoryId) => `${API_BASE_URL}/price-config/${categoryId}`,
    create: () => `${API_BASE_URL}/price-config`,
    update: (id) => `${API_BASE_URL}/price-config/${id}`,
    applyPrices: () => `${API_BASE_URL}/price-config/apply-prices`,
  },
};

export const ADMIN_CONFIG = {
  productsPerPage: 20,
  debounceDelay: 500,
  maxFileSize: 5 * 1024 * 1024, // 5MB
  allowedImageTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
};

export default API_ENDPOINTS;
